import _createForOfIteratorHelper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import { logger as E } from "../../shared-lib/index.js";
import Xt from "../models/backend-errors.js";
import { getErrorMessage as si } from "./error-utils.js";
var a = {
  O: function O(t) {
    var e, o;
    try {
      var r = function r() {
        E.error("This browser does not have any supported ajax options!");
      };
      var n = !1;
      if (window.XMLHttpRequest && (n = !0), !n) return void r();
      e = new XMLHttpRequest();
      var s = function s(o) {
        "function" == typeof t.error && t.error(e.status), "function" == typeof t.tt && t.tt(!1, o);
      };
      e.onload = function () {
        var o = !1;
        if (4 !== e.readyState) return;
        o = e.status >= 200 && e.status < 300 || 304 === e.status;
        var r = e.getAllResponseHeaders();
        if (o) {
          if ("function" == typeof t.W) {
            var _o;
            try {
              _o = JSON.parse(e.responseText);
            } catch (o) {
              var _n = {
                error: "" === e.responseText ? Xt.vu : Xt.Ru,
                response: e.responseText
              };
              (0, t.W)(_n, r);
            }
            _o && t.W(_o, r);
          }
          "function" == typeof t.tt && t.tt(!0, r);
        } else s(r);
      }, e.onerror = function () {
        s(e.getAllResponseHeaders());
      }, e.ontimeout = function () {
        s();
      }, o = JSON.stringify(t.data), e.open("POST", t.url, !0), e.setRequestHeader("Content-type", "application/json"), e.setRequestHeader("X-Requested-With", "XMLHttpRequest");
      var i = t.headers || [];
      var _iterator = _createForOfIteratorHelper(i),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _t = _step.value;
          e.setRequestHeader(_t[0], _t[1]);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      e.send(o);
    } catch (t) {
      E.error("Network request error: ".concat(si(t)));
    }
  }
};
export var readResponseHeaders = function readResponseHeaders(t) {
  var e = {},
    o = t.toString().split("\r\n");
  if (!o) return e;
  var r, n;
  var _iterator2 = _createForOfIteratorHelper(o),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _t2 = _step2.value;
      _t2 && (r = _t2.slice(0, _t2.indexOf(":")).toLowerCase().trim(), n = _t2.slice(_t2.indexOf(":") + 1).trim(), e[r] = n);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return e;
};
export default a;